import { categories } from '@/mocks/categories';
import { categoryImages } from '@/mocks/categoryImages';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end gap-4 mb-12">
          <div className="flex-1">
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-800 text-xs font-medium rounded-full mb-3">
              Browse Categories
            </span>
            <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-[1.15] max-w-lg">
              Explore Every <span className="italic">Pandabuy Sheet</span> Category
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md leading-relaxed">
            From sneakers to streetwear, accessories to tech — every pandabuy spreadsheet category is organized for quick discovery.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-2xl overflow-hidden border-2 border-background-200/60 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={categoryImages[cat.imageSeq] || categoryImages['cat-other-14']}
                  alt={`Pandabuy ${cat.name} spreadsheet finds`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/15 via-transparent to-transparent"></div>
                {/* Category name overlay on image */}
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <span className="inline-block px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-md text-xs font-semibold text-foreground-900">
                    {cat.name}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-4">
                <p className="text-xs text-foreground-500 mb-3 leading-relaxed">{cat.description}</p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:text-primary-700 whitespace-nowrap">
                  Explore Spreadsheet
                  <i className="ri-arrow-right-up-line text-sm group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}